import React from 'react';
import './vendorForm.less';

class CloseModal extends React.Component {
  render() {
    if (!this.props.show) {
      return null;
    }
    return (
      <div className="modal-backdrop">
        <div className="modal-content">
          <p>{this.props.message}</p>
          <button onClick={this.props.onClose}>Close</button>
        </div>
      </div>
    );
  }
}

export default CloseModal;
